<template>
  <div class="main">
    <div class="wrapper">
    </div>
  </div>
</template>
<script>
import { addInfo } from "@/api/litter";
export default {
  data() {
    return {
      nav: [
        { title: "联系方式", url: "lxfs" },
        { title: "加入我们", url: "jrwm" },
        { title: "留言板", url: "lyb" }
      ],
      messageData: {
        workaddress: "",
        name: "",
        phone: "",
        sug: ""
      }
    };
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {
    // 留言板提交
    async submit() {
      // 手机号格式验证
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (
        this.messageData.workaddress &&
        this.messageData.name &&
        this.messageData.phone &&
        this.messageData.sug
      ) {
        if (myreg.test(this.messageData.phone)) {
          let sData = new FormData();
          sData.append("workunit", this.messageData.workaddress);
          sData.append("name", this.messageData.name);
          sData.append("contactway", this.messageData.phone);
          sData.append("leaveword", this.messageData.sug);
          let meg = await addInfo(sData);
          if (meg.code == "OK") {
            this.$message.success("提交成功");
            this.messageData = {
              workaddress: "",
              name: "",
              phone: "",
              sug: ""
            };
            this.isShow = false;
          } else {
            this.$message.warning(meg.msg);
          }
        } else {
          this.$message.warning("联系电话格式不正确");
        }
      } else {
        this.$message.warning("有选项未填写");
      }
    }
  },
  components: {
  }
};
</script>
<style lang="less" scoped>
@color: #0687c8;
.main {
  width: 100%;
  margin-top: 20px;
  .wrapper {
    width: 90%;
    margin: 50px auto 100px;
    .box {
      width: 90%;
      margin: 0 auto;
      h3 {
        font-size: 20px;
        color: #000;
        text-align: center;
        margin: 30px 0 50px;
      }
      p {
        font-size: 14px;
        color: #666;
        margin-bottom: 15px;
      }
      .el-input {
        margin-bottom: 30px;
        width: 100%;
        height: 32px;
      }
      h4 {
        width: 185px;
        height: 44px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 44px;
        background-color: @color;
        color: #ffffff;
        padding: 0 20px 0 30px;
        text-align: center;
        margin: 30px 0 30px auto;
        cursor: pointer;
      }
    }
  }
}
</style>